<template src="./template.html"></template>

<script>
  import RatingModule from '@/components/modules/RatingModule'

  export default {
    name: 'RatingPage',
    components: {
      RatingModule,
    },
  }
</script>
